import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

export class SetSingleTagTypingState implements IBrickInstanceTargetingAction {
   public static readonly type = '[SingleCallTagBehaviour] Set Single Tag Typing State';

   constructor(public brickInstanceId: string, public isTyping: boolean) {}
}
